import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NewUserExperience" */ './lazyIndex'),
    { name: 'NewUserExperience' }
);

export const lazyInvokeUserIntentDialog: LazyAction<
    typeof lazyIndex.invokeUserIntentDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.invokeUserIntentDialog);
export const lazyLoadNewUserDefaultTheme: LazyAction<
    typeof lazyIndex.loadNewUserDefaultTheme,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadNewUserDefaultTheme);

export { default as isNewUserPostJit } from './utils/isNewUserPostJit';
